
import * as ipxRuntime$Sh9_85dqx5jKCFKUcFNJ9tt0ky_G9zoGXrrmOY3E1Ys from '/home/ubuntu/e_com_frontend/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "png",
    "jpeg",
    "jpg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$Sh9_85dqx5jKCFKUcFNJ9tt0ky_G9zoGXrrmOY3E1Ys, defaults: {} }
}
        